export const BILL = 'casual';
export const TICKET = 'ticket';
export const SUBSCRIPTION = 'subscription';
export const TARIFF = 'tariff';
export const ADVANCED_TARIFF = 'advanced_tariff';
export const TIPS = 'tips';

import BillInvoicing from './components/BillInvoicing';
import TicketInvoicing from './components/TicketInvoicing';
import SubscriptionInvoicing from './components/SubscriptionInvoicing';
import TariffInvoicing from './components/TariffInvoicing';
import AdvancedTariffInvoicing from './components/AdvancedTariffInvoicing';
import TipsInvoicing from './components/TipsInvoicing';

export const COMPONENTS_MAP = {
  [BILL]: BillInvoicing,
  [TIPS]: TipsInvoicing,
  [TICKET]: TicketInvoicing,
  [SUBSCRIPTION]: SubscriptionInvoicing,
  [TARIFF]: TariffInvoicing,
  [ADVANCED_TARIFF]: AdvancedTariffInvoicing,
};

export const MAX_TARIFFS = 10;
export const DEFAUL_CATEGORY_CODE = 'OTHERS';
